<template>
  <div>
    <el-popover v-model="isShowShare" placement="bottom-start" trigger="hover">
      <img
        slot="reference"
        src="@saas/pages/assets/images/live/export.png"
        alt=""
      />
      <div class="share-box">
        <div class="share-title">分享课程</div>
        <div class="share-content">
          <div class="left">
            <div class="qr-code__box">
              <create-qr-code
                v-if="courseInfo.id"
                ref="qrCode"
                :url="courseDetailUrl"
                :logo-url="logoUrl"
                :canvas-width="90"
                :canvas-height="90"
                :download-name="downloadName"
                @create-qr-code="getQrCodeUrl"
              />
            </div>
            <div class="qr-code__text">微信/QQ 扫码分享</div>
            <div class="download-btn" @click="handleDownload()">下载二维码</div>
          </div>
          <div class="right">
            <div class="share-item" @click="handleShare('weibo')">
              <div class="icon">
                <img src="@saas/pages/assets/images/live/weibo.png" alt="" />
              </div>
              <span class="text">微博</span>
            </div>
            <div class="share-item" @click="handleCreatePoster">
              <div class="icon">
                <img src="@saas/pages/assets/images/live/image.png" alt="" />
              </div>
              <span class="text">生成海报</span>
            </div>
            <div class="share-item" @click="handleCopy">
              <div class="icon">
                <img src="@saas/pages/assets/images/live/link.png" alt="" />
              </div>
              <span class="text">复制课程链接</span>
            </div>
          </div>
        </div>
      </div>
    </el-popover>
    <poster
      :key="courseInfo.id"
      ref="poster"
      :course-info="courseInfo"
      :qr-code-url="qrCodeUrl"
      @getPosterUrl="getPosterUrl"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import CreateQrCode from "@saas/components/src/components/CreateQrCode";
import shareSdk from "@saas/components/src/utils/share";
import { copyPageUrl, clipboard } from "@saas/components/src/utils/utils";
import { uploadLiveLog } from "@saas/components/src/utils/log";
// import Poster from "@saas/components/src/components/Poster";
import Poster from "./Poster";
export default {
  components: {
    CreateQrCode,
    Poster,
  },
  data() {
    return {
      logoUrl: process.env.VUE_APP_CDN_URL + "/cdn/static/images/favicon.ico",
      qrCodeUrl: "",
      isShowPoster: false,
      isShowDownload: false,
      posterUrl: "",
      isShowShare: false,
    };
  },
  computed: {
    ...mapState("live", [
      "cameraList",
      "liveService",
      "microphoneList",
      "speakerList",
      "layout",
      "roomInfo",
      "courseInfo",
    ]),
    userInfo() {
      return this.$store.getters.user || {};
    },
    courseDetailUrl() {
      return `${process.env.VUE_APP_SAAS_WEB_URL}/product-detail/${this.courseInfo.id}`;
    },
    downloadName() {
      return "二维码-" + this.courseInfo.course_name + ".png";
    },
  },
  methods: {
    getQrCodeUrl(url) {
      this.qrCodeUrl = url;
    },
    // 下载二维码
    handleDownload() {
      uploadLiveLog({
        message: "用户点击分享下载二维码",
        extra: {
          component: "Share",
          action: "click_share_download_qr",
          courseId: this.courseInfo?.id,
        },
      });

      console.log(this.courseInfo);

      this.$refs.qrCode.saveCode();
    },
    // 分享
    handleShare(type) {
      uploadLiveLog({
        message: "用户点击分享微博",
        extra: {
          component: "Share",
          action: "click_share_weibo",
          courseId: this.courseInfo?.id,
          courseName: this.courseInfo?.course_name,
        },
      });

      shareSdk("weibo", {
        url: this.courseDetailUrl, // 分享地址
        title: this.courseInfo.course_name, // 分享标题
        pic: this.courseInfo.cover_url,
      });
    },
    // 生成海报
    handleCreatePoster() {
      uploadLiveLog({
        message: "用户点击分享生成海报",
        extra: {
          component: "Share",
          action: "click_share_create_poster",
          courseId: this.courseInfo?.id,
        },
      });

      this.$refs.poster.open();
    },
    // 复制课程链接
    handleCopy() {
      uploadLiveLog({
        message: "用户点击分享复制课程链接",
        extra: {
          component: "Share",
          action: "click_share_copy_link",
          courseId: this.courseInfo?.id,
          isElectron: window.isElectron,
        },
      });

      if (window.isElectron) {
        clipboard(this.courseDetailUrl, () => {
          this.$showToast("复制成功");
          this.isShowShare = false;
        });
      } else {
        copyPageUrl("复制成功", this.courseDetailUrl);
        this.isShowShare = false;
      }
    },
    getPosterUrl(url) {
      this.posterUrl = url;
    },
  },
};
</script>

<style lang="scss" scoped>
.share-box {
  .share-title {
    font-weight: 400;
    font-size: 14px;
    color: #0d1400;
    line-height: 20px;
    padding-top: 2px;
    text-align: center;
  }
  .share-content {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin-top: 18px;
    height: 134px;
    .left {
      height: 100%;
      width: 148px;
      display: flex;
      flex-direction: column;
      align-items: center;
      border-right: 1px solid #f2f3f5;
      .qr-code__box {
        width: 90px;
        height: 90px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .qr-code__text {
        margin-top: 5px;
        font-weight: 400;
        font-size: 14px;
        color: #0d1400;
        line-height: 20px;
      }
      .download-btn {
        margin-top: 2px;
        cursor: pointer;
        font-weight: 400;
        font-size: 12px;
        color: #00c89d;
        line-height: 17px;
      }
    }
    .right {
      width: 162px;
      height: 100%;
      padding-left: 14px;
      .share-item {
        cursor: pointer;
        border-radius: 6px;
        width: 100%;
        height: 32px;
        display: flex;
        align-items: center;
        padding-left: 6px;
        &:hover {
          background: #f6f8fc;
        }
        .icon {
          width: 20px;
          height: 20px;
          margin-right: 6px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .text {
          font-weight: 400;
          font-size: 14px;
          color: #0d1400;
          line-height: 20px;
        }
      }
    }
  }
}
</style>
